module.exports = __webpack_public_path__ + "media/images/athletes/1653-460cd664393c24eb6f2fc0dc0029c152.png";